import ContactForm from '../components/ContactForm.js';

function Contact() {
    return (
        <div>
            <ContactForm></ContactForm>
        </div>
    )
}

export default Contact;